/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailChangeResult
 */
export interface EmailChangeResult {
    /**
     * 
     * @type {string}
     * @memberof EmailChangeResult
     */
    email: string;
}

export function EmailChangeResultFromJSON(json: any): EmailChangeResult {
    return EmailChangeResultFromJSONTyped(json, false);
}

export function EmailChangeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailChangeResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function EmailChangeResultToJSON(value?: EmailChangeResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}


